<template>
  <div
    class="c_search d_f ali_c"
    :class="!isShow&&!isBack ? 'pad0' : ''"
  >
    <div
      v-if="isBack"
      class="back_img flex_1"
    >
      <img
        src="../assets/img/th_back.png"
        alt=""
        class="cur_p"
        @click="revert"
      >
    </div>
    <div v-if="isShow">
      <div
        v-if="!isW"
        class="cs_text flex_1"
        :class="isBack ? 'mr_less' : ''"
      >
        滨海新区
      </div>
      <div
        v-else
        class="cs_w flex_1 d_f ali_c"
      >
        <van-image
          fit="cover"
          :src="wInfo.httpsiconsiteday"
        >
          <template #loading>
            <img
              src="../assets/img/img_loading.png"
              alt=""
            >
          </template>
        </van-image>
        <span>{{ wInfo.temp_day }}</span><span>°</span>
      </div>
    </div>
    <div
      class=" d_f ali_c h_input"
      :class="getClass()"
    >
      <img
        src="../assets/img/search_black.png"
        alt=""
      >
      <input
        type="text"
        placeholder="搜索景点/美食/酒店/商圈等"
        readonly
        @click="$router.push('/search')"
      >
    </div>
  </div>
</template>

<script>
  import url1 from  '../assets/img/m_2.png'
  export default {
    name: "Search",
    props:{
      isW:{//是否展示天气
        type:Boolean,
        default:false
      },
      isShow:{//是否展示左边那一坨
        type:Boolean,
        default:true
      },
      isBack:{//是否展示返回按钮
        type:Boolean,
        default:false
      },
    },
    data() {
      return {
        url1:url1,
        wInfo:{},
        isDestroyed:false,
      }
    },
    beforeUnmount(){
      console.log(1111111111)
      this.isDestroyed = true;
      console.log(this.isDestroyed)
    },
    created() {

      this.weatherjson();
    },
    methods: {
      revert(){
        if (window.history.length <= 1) {
          this.backApp()
          return false
        } else {
          this.$router.go(-1)
        }
        //上面都没执行就说明卡在当前页不是最后一条， histroy记录数量大于1，又没有回退记录，只能返回首页，
        //如果上面都执行了 页面都跳走了，这个也就不用管了

        setTimeout(() => {
          console.log(this.isDestroyed)
          if(this && !this.isDestroyed){//isDestroyed 组件是否被销毁
            console.log('this.isDestroyed)')
            this.backApp()
          }
        },1000)
      },
      backApp(){
        localStorage.removeItem('map');
        // localStorage.clear()
        if(this.$global.modelState){
          window.android.exit();
        }else {
          this.$iosMethod(function(bridge) {
            bridge.callHandler('exit', null,function(data) {

            })
          })
        }
      },
      // 获取天气
      weatherjson(){
        this.$api.weatherjson('binhaixinqu').then(res => {
          this.wInfo = res.weatherJson.today
        }).catch(err => {

        })
      },
      getClass(){
        if(this.isW){
          return ' w'
        }
        if(!this.isShow && !this.isBack){
          return ' long'
        }
        if(this.isBack && !this.isShow){
          return ' back'
        }
        if(this.isBack && this.isShow){
          return ' back_s'
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .c_search{

    .back_img{
      img{
        width: 18px;
        height: 34px;
      }
    }
    &.pad0{
      padding: 0;
    }
    .cs_w{
      .van-image{
        width: 40px;
        height: 30px;
        margin-right: 8px;
      }
      margin-right: 18px;
      font-size: 28px;
      color: #aaa;
    }
    .h_input{
      &.long{
        width: 100%;
        background-color: white;
        border: none;
        box-shadow: none;
      }
      &.w{
        width: 596px;
      }
      &.back{
        background-color: white;
        width: 658px;
      }
      &.back_s{
        background-color: white;
        width: 480px;
      }
      width: 515px;
      height: 71px;
      border-radius: 35px;
      padding: 13px 23px;
      box-sizing: border-box;
      box-shadow: 0 0 2px 2px #D0D0D0;
      img{
        width: 44px;
        height: 46px;
      }
      input{
        width: calc(100% - 44px);
        box-sizing: border-box;
        padding-left: 20px;
        font-size: 28px;
        font-weight: bold;
        color: #333;
        border: none;
        outline: none;
        background-color: transparent;
        &::placeholder{
          font-size: 28px;
          font-weight: bold;
          color: #D0D0D0;
        }
      }
    }
    .cs_text{
      &.mr_less{
        margin-right: 10px;
      }
      font-size: 36px;
      font-weight: bold;
      color: #1E1E1E;
      margin-right: 23px;
    }
    padding: 25px 21px 20px 27px;
  }

</style>
